import { axiosInstance } from '@/config/axios.config';
import {
  PromoBannerRequest,
  PromoBannerResponse,
  UpdatePromoBannerRequest,
} from '@repo/types/src/promo-banner';

export const getAllPromoBanners = async () => {
  const response = await axiosInstance.get<PromoBannerResponse[]>(
    '/promo-banner/admin',
  );
  return response.data;
};

const buildFormData = (
  payload: PromoBannerRequest | UpdatePromoBannerRequest,
) => {
  const formData = new FormData();
  if ('file' in payload && payload.file) formData.append('file', payload.file);
  formData.append('region', payload.region);
  formData.append('textParts', JSON.stringify(payload.textParts));
  formData.append('buttonText', payload.buttonText);
  formData.append('buttonLink', payload.buttonLink);
  return formData;
};

export const createPromoBanner = async (payload: PromoBannerRequest) => {
  const response = await axiosInstance.post<PromoBannerResponse>(
    '/promo-banner/admin',
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const updatePromoBanner = async (
  id: number,
  payload: UpdatePromoBannerRequest,
) => {
  const response = await axiosInstance.patch<PromoBannerResponse>(
    `/promo-banner/admin/${id}`,
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const activatePromoBanner = async (id: number) => {
  const response = await axiosInstance.patch<PromoBannerResponse>(
    `/promo-banner/admin/${id}/activate`,
  );
  return response.data;
};

export const deactivatePromoBanner = async (id: number) => {
  const response = await axiosInstance.patch<PromoBannerResponse>(
    `/promo-banner/admin/${id}/deactivate`,
  );
  return response.data;
};

export const deletePromoBanner = async (id: number) => {
  const response = await axiosInstance.delete<PromoBannerResponse>(
    `/promo-banner/admin/${id}`,
  );
  return response.data;
};
